import { lazyPage } from '@/lib/lazy-page'
import { defineModule } from '@/lib/module-routes'

import { entityAiSettingsRoute } from './routes'

const AssistantSettingsSection = lazyPage(
  () => import('./features/ai-settings/entity-ai-settings.lazy'),
  'AssistantSettingsSection',
)

const ExternalMcpSection = lazyPage(
  () => import('./features/ai-settings/external-mcp-section.lazy'),
  'ExternalMcpSection',
)

export const assistantModule = defineModule({
  routes: [entityAiSettingsRoute],
  generalSettingsSections: [
    { id: 'assistant', component: AssistantSettingsSection },
    { id: 'external-mcp', component: ExternalMcpSection },
  ],
})
